var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "organization", style: { top: _vm.fixedTop + "px" } },
    [
      _c(
        "van-dropdown-menu",
        { attrs: { "active-color": "#1989fa" } },
        [
          _c("van-dropdown-item", {
            attrs: { options: _vm.option1 },
            on: { change: _vm.getLabList },
            model: {
              value: _vm.collegeId,
              callback: function($$v) {
                _vm.collegeId = $$v
              },
              expression: "collegeId"
            }
          }),
          _vm._v(" "),
          _c(
            "van-dropdown-item",
            {
              ref: "labVd",
              attrs: { title: _vm.labName },
              model: {
                value: _vm.labId,
                callback: function($$v) {
                  _vm.labId = $$v
                },
                expression: "labId"
              }
            },
            [
              _c("template", { slot: "title" }, [
                _vm.labName != ""
                  ? _c("div", { staticClass: "dropdownTitle" }, [
                      _c("span", { staticClass: "labName" }, [
                        _vm._v(_vm._s(_vm.labName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "totalNum" },
                        [
                          _c("van-badge", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.totalNum != 0,
                                expression: "totalNum!=0"
                              }
                            ],
                            staticStyle: { "font-size": "12px" },
                            attrs: { content: _vm.totalNum }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._l(_vm.option2, function(item) {
                return _c(
                  "van-cell",
                  {
                    key: item.value,
                    attrs: { center: "" },
                    on: {
                      click: function($event) {
                        _vm.selectLab(item.value, item.text, item.num)
                      }
                    }
                  },
                  [
                    _c(
                      "template",
                      { slot: "title" },
                      [
                        _c(
                          "span",
                          {
                            class: { blueColor: item.text == _vm.labName },
                            staticStyle: { "margin-right": "16px" }
                          },
                          [_vm._v(_vm._s(item.text))]
                        ),
                        _vm._v(" "),
                        _c("van-badge", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.num != 0,
                              expression: "item.num!=0"
                            }
                          ],
                          staticStyle: { "font-size": "12px" },
                          attrs: { content: item.num }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "template",
                      { slot: "right-icon" },
                      [
                        _c("van-icon", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.text == _vm.labName,
                              expression: "item.text==labName"
                            }
                          ],
                          attrs: { name: "success", color: "#1989fa" }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70dbe046", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70dbe046","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/organizationAutoShowNum/index.vue
// module id = null
// module chunks = 